export const RETURNS_SETTINGS_PORTALS_CREATE = 'RETURNS_SETTINGS_PORTALS_CREATE'
export const RETURNS_SETTINGS_PORTALS_FETCH_ALL = 'RETURNS_SETTINGS_PORTALS_FETCH_ALL'
export const RETURNS_SETTINGS_PORTALS_UPDATE = 'RETURNS_SETTINGS_PORTALS_UPDATE'
export const RETURNS_SETTINGS_STORE_PAYMENT_PROVIDER = 'RETURNS_SETTINGS_STORE_PAYMENT_PROVIDER'
export const RETURNS_SETTINGS_PAYMENT_PROVIDER_DISCONNECT = 'RETURNS_SETTINGS_PAYMENT_PROVIDER_DISCONNECT'
